import { SocialProofItem } from './SocialProofBanner.types'

export const mockSocialProofItems: SocialProofItem[] = [
  {
    imageUrl: '/images/socialProofImages/associatedPressGrey.png',
    linkUrl: '',
    altText: 'Associated Press'
  },
  {
    imageUrl: '/images/socialProofImages/bbcMoneyGrey.png',
    linkUrl: '',
    altText: 'BBC Money'
  },
  {
    imageUrl: '/images/socialProofImages/bostonHeraldGrey.png',
    linkUrl: '',
    altText: 'Boston Herald'
  },
  {
    imageUrl: '/images/socialProofImages/digitalJournalGrey.png',
    linkUrl: '',
    altText: 'Digital Journal'
  },
  {
    imageUrl: '/images/socialProofImages/marketWatchGrey.png',
    linkUrl: '',
    altText: 'Market Watch'
  }
]
